export default {"src":"/_next/static/media/user.d0079774.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};